import {
    getCateringEventBySlug,
    GetCateringEventBySlugApiResponseSchema,
} from './get-catering-event-by-uid';

export {
    GetCateringEventBySlugApiResponseSchema,
};

export const CateringEventPageActions = {
    getCateringEventBySlug,
};
